import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import classes from "./Cart.module.css";

const ModalComponent = (props) => {
  const { t, i18n } = useTranslation();
  const [modalShow, setModalShow] = useState(false);
  const [steps, setSteps] = useState(1);
  const [continueBtn, setContinueBtn] = useState(true);
  const [myAddress, setMyAddress] = useState([
    {
      id: 1,
      address: "6 October - Zone 6",
      street: "Bank Street - Front Institute Syaha W Fnad2",
      building: "Building 1",
      flat: "Flat 10",
    },
    {
      id: 2,
      address: "6 October - Zone 6",
      street: "Bank Street - Front Institute Syaha W Fnad2",
      building: "Building 1",
      flat: "Flat 10",
    },
    {
      id: 3,
      address: "6 October - Zone 6",
      street: "Bank Street - Front Institute Syaha W Fnad2",
      building: "Building 1",
      flat: "Flat 10",
    },
  ]);

  const formRadioValue = (event) => {
    console.log(event.target.value);
    setContinueBtn(false);
  };

  return (
    <React.Fragment>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Address
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.formAddress}>
            <form>
              {steps === 1 ? (
                <div className={classes.addressStep}>
                  {myAddress.map((row, index) => {
                    return (
                      <div className={classes.formCheckbox}>
                        <div className={classes.checkInput}>
                          <input
                            id={`toggleAddres${row.id}`}
                            type="radio"
                            name={`toggle-address`}
                            value={`addres-${row.id}`}
                            onChange={formRadioValue}
                          />
                          <div className={classes.fakeRadio}></div>
                          <label
                            for={`toggleAddres${row.id}`}
                            className={classes.addressData}
                          >
                            <div className={classes.checkAddrees}>
                              {row.address}
                            </div>
                            <div className={classes.checkNearest}>
                              {row.street}
                            </div>
                            <div className={classes.checkBuilding}>
                              {row.building},
                            </div>
                            <div className={classes.checkFlat}>{row.flat}</div>
                          </label>
                        </div>

                        <div className={classes.formCheckActions}>
                          <button
                            type="button"
                            className={classes.checkActionBtn}
                          >
                            <span
                              className={`icon-trash ${classes.checkActionIcon}`}
                            ></span>
                          </button>
                          <button
                            type="button"
                            className={classes.checkActionBtn}
                          >
                            <span
                              className={`icon-edit ${classes.checkActionIcon}`}
                            ></span>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                  <div className={classes.addNewAddress}>
                    <button type="button" className={classes.addNewAddressBtn}>
                      Add New Address
                    </button>
                  </div>
                </div>
              ) : (
                ""
              )}

              {steps === 2 ? (
                <div class={classes.checkoutStep}>Checkout Container</div>
              ) : (
                ""
              )}

              <div className={classes.continueCheckout}>
                {steps === 2 ? (
                  <div>
                    <button
                      type="button"
                      className={`${classes.backBtn}`}
                      onClick={() => setSteps(1)}
                    >
                      Back
                    </button>
                  </div>
                ) : (
                  ""
                )}
                <div className={classes.continueCheckoutDiv}>
                  <button
                    type="button"
                    className={`main-button ${classes.continueBtn}`}
                    onClick={() => setSteps(2)}
                    disabled={continueBtn}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <button
            className={`main-button ${classes.closeModal}`}
            onClick={props.onHide}
          >
            Close
          </button>
        </Modal.Footer> */}
      </Modal>
    </React.Fragment>
  );
};

export { ModalComponent };
